module.exports = __webpack_public_path__ + "img/quotes-with-white-bg.b0eeef2c.png";